import styled from "styled-components";

export const ClickShield = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${(props) =>
    props.light ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.4)"};
  z-index: 10;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  input,
  textarea,
  select,
  button {
    font-family: "Lato", Helvetica, Arial, sans-serif;
  }
`;

export const Header = styled.div`
  background: ${(props) => props.colour};
  display: flex;
  color: white;
  padding: 15px 32px;
  align-items: center;
`;

export const RowSpaced = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &:first-child {
    width: 100%;
    flex: 1;
  }
`;

export const HeaderInput = styled.input`
  background: transparent;
  color: white;
  border: none;
  font-size: 32px;
  width: 100%;
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => (props.readOnly ? "none" : "0 1px 0 #fff")};
  }
`;

export const CloseIcon = styled.div`
  font-size: 32px;
  cursor: pointer;
  &:hover {
    font-size: 33px;
  }
`;

export const Label = styled.div`
  flex: 1;
  text-align: ${(props) => (props.vertical ? "left" : "right")};
  ${(props) => (props.vertical ? "margin-bottom: 32px" : "margin-right: 32px")};
  font-weight: ${(props) => (props.dark ? "600" : "400")};
`;

export const ModalLabel = styled.div`
  font-size: 14px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
`;

export const DateAddedLabel = styled.div`
  font-size: 14px;
  letter-spacing: 1.4px;
`;

export const Row = styled.div`
  display: flex;
  position: relative;
  flex-direction: ${(props) => (props.vertical ? "column" : "row")};
  ${(props) => (props.vertical ? "" : "align-items:center")};
  margin-bottom: ${(props) => (props.vertical ? "0" : "8px")};
  height: 100%;
  ${(props) => (props.vertical ? "overflow-y: auto" : null)};
`;

export const Input = styled.input`
  flex: 3;
  height: 40px;
  border-radius: 4px;
  border: ${(props) =>
    props.readOnly ? "none" : "solid 1px rgba(63, 65, 84, 0.2)"};
  padding-left: 16px;
`;

export const Columns = styled.div`
  display: flex;
  flex: 1;
`;

export const Pane = styled.div`
  height: 100%;
  width: 50%;
  padding: 32px;
  overflow-y: auto;
  &:first-child {
    border-right: solid 3px rgba(185, 185, 196, 0.17);
  }
`;

export const FlexPane = styled(Pane)`
  display: flex;
  justify-content: ${(props) =>
    props.justify ? props.justify : "space-between"};
  flex-direction: column;
`;

export const NoScrollPane = styled(Pane)`
  overflow: hidden;
`;

export const TextArea = styled.textarea`
  flex: 1;
  border-radius: 4px;
  border: solid 1px rgba(63, 65, 84, 0.2);
  height: 80%;
  font: lato;
  font-size: 0.85rem;
  resize: none;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  padding: 16px 0px;
  @media (max-width: 420px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.8);
  }
`;

export const Text = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  white-space: normal;
  text-align: left;
  min-width: 100%;
`;

export const NoteContainer = styled.div`
  &:first-child {
    height: 90%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Modals/modal.styles.js